/* global jQuery espn_ui espn */
import config from '../../../config'
import ads from './ads'

export const shell = {
  setContainer() {
    espn_ui.Helpers.page.container = jQuery('#main-container')
  },
  transition: {
    start() {
      jQuery(`#${config.uid}`).attr('style', 'opacity:0')
    },
    end() {
      jQuery(`#${config.uid}`).attr('style', 'opacity:1')
    },
    preRender(edition, sport, template, team, league) {
      try {

        shell.unloadAds()

        // arguments to be passed to page.preRender
        // [  url, pagetype, prefetch, autoCSS, customStyleSheet ]
        const args = [ '', template, false, null ]

        switch(template) {
          case 'gamepackage':
            if ( sport === 'rugby-league' ) {
              args.push('game-package-rugby')
            } else {
              args.push(`game-package-${sport}`)
            }
            break
          case 'scoreboard':
            if(sport === 'rugby') {
              args.push(`scoreboards-${sport}`)
            } else if ( sport === 'rugby-league' ) {
              args.push('scoreboards-rugby')
            } else if(sport == 'cricket') {
              args.push('score-center')
            }
            break
        }
        jQuery(document).trigger('page.preRender', args)

        espn_ui.Helpers.page.react = true

        espn_ui.Helpers.page.pathname = location.pathname

        espn_ui.Helpers.page.template = template

        shell.updateClassNames(template, sport)

        shell.updateAds(template, edition)

        //disable header scoreboard for cricinfo/scores
        shell.showHideScoreboard(template, edition.site, team, league)

      }catch(e) {
        console.log(e)
      }
    },
    postRender(sport, template, ads = {}, analytics = {}, tier3Nav, tier2Nav) {
      try{
        const stateProps = {
          isScoreNode: true,
          url: location.href,
          react: true,
          type: template
        }

        if(Object.keys(ads).length) {
          stateProps.ads = ads
        }

        if(Object.keys(analytics).length) {
          stateProps.analytics = analytics
        }

        switch(template) {
          case 'gamepackage':
            if ( sport === 'rugby' || sport === 'rugby-league' ) {
              stateProps.customStyleSheet = 'game-package-rugby'
            } else if ( sport === 'cricket' ) {
              stateProps.customStyleSheet = 'game-package-cricket'
            }
            break
          case 'scoreboard':
            if ( sport === 'rugby' || sport === 'rugby-league' ) {
              stateProps.customStyleSheet = 'scoreboards-rugby'
            } else if(sport == 'cricket') {
              stateProps.customStyleSheet = 'score-center'
            }
            break
          case 'standings':
            break
        }

        shell.setContainer()

        espn_ui.Helpers.page.contentPreBehavior = espn_ui.Helpers.page.container.html()

        const newState = espn_ui.Helpers.history.getStateData()
        newState.content.html = espn_ui.Helpers.page.container.html()
        newState.meta.type = template
        newState.sport = [ sport ]

        tier3Nav = tier3Nav || espn.nav && espn.nav.tier3
        tier2Nav = tier2Nav || espn.nav && espn.nav.tier2

        if(tier3Nav) {
          newState.tier3Nav = tier3Nav
        }

        if(tier2Nav) {
          newState.tier2Nav = tier2Nav
        }

        Object.keys(stateProps).map(key => {
          newState[key] = stateProps[key]
        })

        // replace history state
        history.replaceState(newState, template, window.location)

      }catch(e) {
        console.log(e)
      }
    }
  },
  updateClassNames(template, sport) {
    const bodyClassNames = {
      add : [ template ],
      remove: []
    }
    const paneMainClassNames = {
      add : [],
      remove: []
    }

    switch(template) {
      case 'gamepackage':
        bodyClassNames.remove.push('standings', 'scoreboard')
        paneMainClassNames.add.push('pre')
        paneMainClassNames.add.push('details-header')
        if (/cricket/.test(sport) === false) {
          paneMainClassNames.add.push('details-header')
        }
        break

      case 'standings':
        bodyClassNames.remove.push('gamepackage', 'scoreboard')
        paneMainClassNames.remove.push('pre', 'details-header', 'details-footer')
        break

      case 'scoreboard':
        bodyClassNames.remove.push('gamepackage', 'standings')
        paneMainClassNames.remove.push('pre', 'details-header', 'details-footer')
        break
    }

    jQuery('body').attr('data-pagetype', template.replace(/\-webview\-.*$/, ''))
      .addClass(bodyClassNames.add.join(' '))
      .removeClass(bodyClassNames.remove.join(' '))

    jQuery('#pane-main')
      .addClass(paneMainClassNames.add.join(' '))
      .removeClass(paneMainClassNames.remove.join(' '))

  },
  unloadAds() {
    try{
      if(location.pathname !== espn_ui.Helpers.page.pathname) {
        ads.unloadAds()
      }
    }catch(e) {
      console.log(e)
    }
  },
  updateAds(template, edition) {
    // Placeholder method to update ads,
    // currently only overlay and wallpaper are hidden
    // on gamepackage for espn.in.
    // TODO: add logic as required for other editions
    const variableAdTypes =[ 'overlay', 'wallpaper' ]
    const selectors = variableAdTypes.map(type => {
      return `.ad-slot-${type}`
    })
    const selectorString = selectors.join(', ')

    if(template === 'gamepackage' && edition && !edition.isEspnCricinfo) {
      jQuery(selectorString).remove()
    }else {

      // TODO: check ads initing on page transitions
      if(!jQuery('.ad-slot-overlay').length && template.indexOf('webview') == -1) {
        jQuery('body').prepend(ads.getSlot('overlay'))
      }

      if(!jQuery('.ad-slot-wallpaper').length) {
        jQuery(ads.getSlot('wallpaper')).insertAfter('#custom-nav')
      }

      /*
       * Scoreheader presby ad will appear for espncricinfo india edition
      */
      if(edition.isAsiaRegion) {
        if(!jQuery('.ad-slot-presby').length) {
          jQuery('.scoreboard-content .scoreboard-menu').after(ads.getSlot('presbyHeader'))
        }
      }

    }
  },
  showHideScoreboard(template, site, team, league) {
    let $el = jQuery('#global-scoreboard')
    if(window.espn_ui) {
      let isDesktop = (window.espn_ui.deviceType === 'desktop') || false
      let isNotDevice = !window.espn_ui.device.isMobile && !window.espn_ui.device.isTablet
      if(site === 'espncricinfo' && isDesktop && isNotDevice) {
        if(template === 'scoreboard' && !team && !league) {
          $el.hide()
        }else{
          if (window.espnSB) {
            $el.show()
            window.espnSB.trigger('resetSB')
          }
        }
      }
    }
  },
  track: {
    init(data) {
      try{
        if(typeof espn.track !== 'undefined' && typeof espn.track.init == 'function') {
          if (data) {
            data.page_url = window.location.href
          }
          espn.track.init(data)
        }
      }catch(e) {
        console.log(e)
      }
    },
    page(props) {
      let espnUI = window.espn_ui
      if (espnUI) {
        let dataLayerHelper = espnUI && espnUI.Helpers && espnUI.Helpers.dataLayer
        if (dataLayerHelper) {
          let page = window.__dataLayer && window.__dataLayer.page || {}
          let metrics = props && props.analytics && props.analytics.metrics

          if (metrics) {
            metrics.page_url = window.location.href
          }

          if (dataLayerHelper.assignDataLayer) {
            dataLayerHelper.assignDataLayer(Object.assign(page, metrics))
          }
        }        
      }
      
      jQuery(document).trigger('page.track', [ props ])
    }
  }
}

export default shell



// WEBPACK FOOTER //
// ../app/lib/utils/shell.js